// FL-02 · Ficha de Cautela Individual — PDF no modelo do Regimento (rev.02)
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const NAVY = [16, 42, 74];
const GOLD = [201, 168, 76];
const TEXT = [30, 41, 59];
const MUTED = [100, 116, 139];
const BORDER = [180, 188, 200];
const PW = 210;
const M = 10;
const fD = (iso) => (iso ? new Date(iso).toLocaleDateString("pt-BR") : "");

export function gerarFL02PDF(cautela) {
  const doc = new jsPDF({ unit: "mm", format: "a4", compress: true });
  doc.setFillColor(...NAVY).rect(0, 0, PW, 15, "F");
  doc.setFillColor(...GOLD).rect(0, 15, PW, 1.1, "F");
  doc.setTextColor(255, 255, 255).setFont("helvetica", "bold").setFontSize(12);
  doc.text("FL-02 · Ficha de Cautela Individual", M, 7.5);
  doc.setFontSize(7).setFont("helvetica", "normal").setTextColor(220, 225, 235);
  doc.text("OBRASUL · Um Show de Obra", M, 11.8);
  doc.setFont("helvetica", "bold").setFontSize(9).setTextColor(...GOLD);
  doc.text(`Folha ${cautela.folha}`, PW - M, 7.5, { align: "right" });
  doc.setFontSize(7).setTextColor(220, 225, 235).setFont("helvetica", "normal");
  doc.text(`${cautela.funcionario_nome}${cautela.funcionario_cargo ? " · " + cautela.funcionario_cargo : ""}`, PW - M, 11.8, { align: "right" });

  let y = 22;
  doc.setFillColor(248, 246, 238).setDrawColor(...GOLD).setLineWidth(0.3);
  doc.roundedRect(M, y, PW - 2 * M, 14, 1, 1, "FD");
  doc.setFontSize(7).setTextColor(...TEXT).setFont("helvetica", "italic");
  doc.text(doc.splitTextToSize(`"${cautela.termo}"`, PW - 2 * M - 6), M + 3, y + 4);
  doc.setFont("helvetica", "normal").setFontSize(6.2).setTextColor(...MUTED);
  doc.text(`Assinado na abertura em ${fD(cautela.aberta_em)} · registrado por ${cautela.aberta_por || ""}`, M + 3, y + 12.5);
  y += 18;

  const corpo = (cautela.itens || []).map((it) => [
    fD(it.data_retirada), it.patrimonio_nome, it.patrimonio_codigo || "", it.quantidade || 1,
    it.obra_titulo || "—", "✓", fD(it.data_devolucao) || "", it.estado_devolucao || "", it.rubrica_logistica || ""]);
  while (corpo.length < 12) corpo.push(["", "", "", "", "", "", "", "", ""]);
  autoTable(doc, {
    startY: y, margin: { left: M, right: M },
    head: [["Data", "Ferramenta / equipamento", "Nº patrim.", "Qtd.", "Obra", "Rubrica colab.", "Devolução", "Estado B/R/D/EXT", "Rubrica Logística"]],
    body: corpo, theme: "grid",
    styles: { fontSize: 6.3, cellPadding: 1.1, textColor: TEXT, lineColor: BORDER, lineWidth: 0.15, minCellHeight: 5.5 },
    headStyles: { fillColor: NAVY, textColor: [255, 255, 255], fontSize: 5.9, halign: "center" },
    columnStyles: { 0: { cellWidth: 17 }, 1: { cellWidth: 48 }, 2: { cellWidth: 18 }, 3: { cellWidth: 9, halign: "center" },
      4: { cellWidth: 32 }, 5: { cellWidth: 16, halign: "center" }, 6: { cellWidth: 18 }, 7: { cellWidth: 18, halign: "center" }, 8: { cellWidth: "auto" } },
  });
  y = doc.lastAutoTable.finalY + 5;

  doc.setFont("helvetica", "bold").setFontSize(7.5).setTextColor(...NAVY);
  doc.text("CONFERÊNCIA MENSAL (Tudo presente? S/N · faltas/danos)", M, y);
  const confs = (cautela.conferencias || []).map((c) => [c.mes, c.tudo_presente ? "S" : "N", c.faltas_danos || "—", c.registrada_por || ""]);
  while (confs.length < 3) confs.push(["", "", "", ""]);
  autoTable(doc, {
    startY: y + 1.5, margin: { left: M, right: M },
    head: [["Mês", "Tudo presente? S/N", "Faltas / danos (item e nº patrimônio)", "Logística"]],
    body: confs, theme: "grid",
    styles: { fontSize: 6.3, cellPadding: 1.1, textColor: TEXT, lineColor: BORDER, lineWidth: 0.15, minCellHeight: 5.5 },
    headStyles: { fillColor: [71, 85, 105], textColor: [255, 255, 255], fontSize: 6 },
    columnStyles: { 0: { cellWidth: 20 }, 1: { cellWidth: 30, halign: "center" }, 2: { cellWidth: 95 }, 3: { cellWidth: "auto" } },
  });
  y = doc.lastAutoTable.finalY + 12;

  const aw = (PW - 2 * M - 20) / 3;
  ["Colaborador", "Logística", "Gerente Operacional e Controle"].forEach((lbl, i) => {
    const x = M + i * (aw + 10);
    doc.setDrawColor(...TEXT).setLineWidth(0.25).line(x, y + 6, x + aw, y + 6);
    doc.setFontSize(5.8).setTextColor(...MUTED);
    doc.text(lbl, x + aw / 2, y + 9, { align: "center" });
  });

  doc.setFillColor(...NAVY).rect(0, 289, PW, 8, "F");
  doc.setFontSize(6.5).setTextColor(255, 255, 255);
  doc.text("OBRASUL · Um Show de Obra · Registro físico obrigatório · FL-02 · rev.02", PW / 2, 294, { align: "center" });
  doc.save(`FL-02_Cautela_${(cautela.funcionario_nome || "").replace(/\s+/g, "_")}_f${cautela.folha}.pdf`);
}
